import { Column, FieldType, FieldValue, O, Section, Table } from "../../../../ui"
import { useDataTypesHooks } from "../../../hooks/dataTypesHooks"
import { Data, Data2 } from "../../../types"

type Props = {
    rows: Data2[]
    readOnly?: boolean
    onCreate?: () => void
    onEditRow?: (phoneStr: string) => void
    onRemoveRow?: (phoneStr: string) => void
}

export const PhonesTable = (props: Props) => {
    const { rows, readOnly, onCreate, onEditRow, onRemoveRow } = props

    const { formatPhone } = useDataTypesHooks()

    const columns: Column[] = [
        {
            name: 'phone',
            type: FieldType.NUMBER,
            label: '',
            render: (value?: FieldValue) => <>{formatPhone(value as O<number>)}</>
        }
    ]

    return (
        <Section
            id="phones"
            collapsable
            defaultExpanded
        >
            <Table
                columns={columns}
                rows={rows as Data[]}
                rowId='phoneStr'
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onCreate}
                onEdit={onEditRow}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
